<script>
/* Utilities */
import ArrayUtil from '../utilities/ArrayUtil'
import AppResourceUtil from '../utilities/AppResourceUtil'
/* APIs */
import UserApi from '../api/UserApi';
import IssueApi from '../api/IssueApi';
/* Constants */
import ValidationCardDbStatus from '../constants/ValidationCardDbStatus'
import Reasons from '../constants/ReasonForStatusChange'
/* UI Components */ 
import { Field } from 'buefy/dist/components/field'
import { Autocomplete } from 'buefy/dist/components/autocomplete'
import { Icon } from 'buefy/dist/components/icon'
import { Input } from 'buefy/dist/components/input'
import { Select } from 'buefy/dist/components/select'
import { Notification } from 'buefy/dist/components/notification'

export default {
    name : "ChangeStatusForm",
    props : {
        vcard : Object,
        profile : Object
    },
    components : {
        'b-field' : Field,
        'b-icon' : Icon,
        'b-input' : Input,
        'b-select' : Select, 
        'b-autocomplete' : Autocomplete, 
        'b-notification' : Notification
    },
    data(){
        return {
            newStatus : '',
            reason : '',
            otherReason : '',
            requestedBy : null,
            users : [],
            userKeyword : '',
            globalError : {
                show : false,
                message : ""
            }
        }
    },
    computed: {
        statusList(){
            if (!this.vcard) {
                return [];
            }
            if (!this.vcard.validationCardStatus) {
                return ValidationCardDbStatus;
            }

            let list = [];
            // Show only previous status
            let statusIdx = ArrayUtil.getIndex(ValidationCardDbStatus,
                                               null,
                                               this.vcard.validationCardStatus);
            if (statusIdx!=null) {
                ValidationCardDbStatus.forEach((s,i)=>{
                    if (i<statusIdx) {
                        list.push(s);
                    }
                })
            }
            return list;
        },
        validForm(){
            if (this.newStatus.trim()=='') {
                return false;
            }
            if (this.reason.trim()=="") {
                return false;
            }
            if (this.userKeyword.trim()=="") {
                return false;
            }
            return true;
        },
        filteredUsers(){
            return this.users.filter((option) => {
                return option.fullName
                    .toString()
                    .toLowerCase()
                    .indexOf(this.userKeyword.toLowerCase()) >= 0
            })
        },
        statusClass(){
            if (this.vcard) {
                switch(this.vcard.validationCardStatus) {
                    case 'No Data Entry': 
                        return 'tag--1'; 
                        break;
                    case 'Data Entry - In Progress': 
                        return 'tag--2'; 
                        break;
                    case 'Ready for Validation': 
                        return 'tag--3'; 
                        break;
                    case 'Validated and Submitted':
                        return 'tag--4'; 
                        break;
                }
            }
        },
        reasonsList(){
            let reasons = [];
            if (this.vcard) {
                switch(this.vcard.validationCardStatus) {
                    case 'Data Entry - In Progress': 
                        reasons.push(Reasons[0]);
                        break;
                    case 'Ready for Validation': 
                        reasons.push(Reasons[1]);
                        reasons.push(Reasons[3]);
                        break;
                    case 'Validated and Submitted':
                        reasons.push(Reasons[2]);
                        reasons.push(Reasons[3]);
                        break;
                }
            }
            reasons.push("Other");
            return reasons;
        },
        optionsLabel(){
            let msg = "There";
            if (this.statusList.length > 1) {
                return `${msg} are ${this.statusList.length} statuses applicable.`
            }
            return `${msg} is only 1 status applicable.`
        }
    },
    created(){
        this.getUsers();
        this.reason = this.reasonsList[0];
    },
    methods : {
        getUsers(){
            this.users = [];
            UserApi.getAll()
            .then(response=>{
                if (response.data) {
                    if (!response.data.error) {
                        this.users = response.data;
                    }
                    else {
                        this.promptServerError({response},'User.getAll');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'User.getAll');
            });
        },
        triggerClose(){
            this.$emit('close')
        },
        triggerSubmit(){
            this.closeError();
            
            if (!this.newStatus || this.newStatus.trim()=='') {
                this.showError('New status is required. Please choose.');
                return false
            }

            if (!this.userKeyword || this.userKeyword.trim()=="") {
                this.showError('Requestor name is required.');
                return false
            }

            var newReason = "";
            if (!this.reason) {
                this.showError('Please select reason for changing the status.');
                return false
            }
            else {
                newReason = this.reason;
            }

            if (this.reason=='Other' && this.otherReason.trim()=="") {
                this.showError("Please fill in 'other reason' for status changed.");
                return false;
            }
            else {
                newReason += " - "+this.otherReason;
            }

            let requestedBy = ArrayUtil.getItemInArray(this.users,
                                                        'fullName',
                                                        this.userKeyword);
            if (requestedBy.length > 0) {
                this.$emit('submit-new-status',{
                    reason : newReason,
                    status : this.newStatus,
                    requestedBy: requestedBy[0].userId,
                    requestedByName: this.userKeyword
                });
            }
            else {
                this.showError('Requestor name is required.');
                return false
            }
        },
        submitError(errorData,api){   
            let obj = {
                email : this.profile.email,
                username : this.profile.username,
                message : "["+errorData.type+" "+errorData.code+"] - "+errorData.message+" Request to: "+api,
                issueStatus : "Pending",
                issueType : "Issue",
                createdBy : this.profile.userId,
                pageName : this.$route.name,
                pageLink : this.$route.path
            };

            if (errorData.hasOwnProperty('query')) {
                obj.message += ' SQL Query: '+errorData.query;
            }

            // Add feedback/issue to DB
            IssueApi.add(obj)
            .then(response=>{
                if (response.data) {
                    if (response.data.issueId) {
                        this.$dialog.alert({
                            title: 'Success',
                            message: "<p><strong>Thanks for reporting!</strong></p><br/>  Admin will check this and get back to you, if necessary.",
                            type: 'is-success'
                        });
                    }
                    else {
                        this.$dialog.alert({
                            title: 'Error',
                            message: "Unable to submit error. Please try again later.",
                            type: 'is-danger'
                        });
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'Issue.add');
            });
        },
        promptServerError(error,api){
            try {
                let returnData = AppResourceUtil.getErrorData(error.response);
                if (returnData.errorData!=null) {
                    this.$dialog.confirm({
                        title: returnData.dialog.title,
                        message: returnData.dialog.message,
                        cancelText: "Close",
                        confirmText: "Submit Error",
                        type: 'is-danger',
                        onConfirm: () => {
                            this.submitError(returnData.errorData,api);
                        }
                    });
                }
            } 
            catch(respError){
                console.log(respError)
            }
        },
        closeError(){
            this.globalError.show = false;
            this.globalError.message = "";
        },
        showError(msg){
            this.globalError.show = true;
            this.globalError.message = msg;
        },
        checkOther(){
            this.otherReason = "";
        }
    }
}
</script>

<template>
    <div class="modal-card" style="width:auto">
        <header class="modal-card-head">
            <p class="modal-card-title">Change Status</p>
        </header>

        <section class="modal-card-body">
            
            <div class="has-text-left is-italic">
                <p>Fields marked with * are mandatory.</p>
            </div>

            <div class="notification is-danger"
                v-if="globalError.show">
                <button class="delete"
                    type="button"
                    v-on:click="closeError"></button>
                <p>{{globalError.message}}</p>
            </div>

            <div class="box">

                <b-field 
                    label="Current Status"
                    v-if="vcard">
                    <span class="tag"
                        v-bind:class="statusClass">{{vcard.validationCardStatus}}</span>
                </b-field> <br/>

                <b-field 
                    label="*New Status"
                    :message="optionsLabel">
                    <b-select 
                        placeholder="Select new status"
                        v-model="newStatus"
                        required>
                        <option
                            v-for="(status,statusIdx) in statusList"
                            v-bind:key="statusIdx"
                            v-bind:value="status">
                            {{status}}
                        </option>
                    </b-select>
                </b-field><br/>

                <b-field 
                    label="*Requested by">
                    <b-autocomplete
                        field="fullName"
                        icon="magnify"
                        placeholder="Search user"
                        v-model="userKeyword"
                        v-bind:data="filteredUsers"
                        v-bind:open-on-focus="true"
                        v-on:select="option => selected = option"
                        required>
                        <template slot="empty">No results found</template>
                    </b-autocomplete>
                </b-field><br/>

                <b-field 
                    label="*Reason for status change">
                    <b-select 
                        placeholder="Select reason"
                        v-model="reason"
                        required
                        v-on:input="checkOther">
                        <option
                            v-for="(reason,reasonIdx) in reasonsList"
                            v-bind:key="reasonIdx"
                            v-bind:value="reason">
                            {{reason}}
                        </option>
                    </b-select>
                </b-field>

                <b-field 
                    label="*Other reason">
                    <b-input
                        :disabled="reason!='Other'"
                        type="textarea"
                        v-model="otherReason"
                        maxlength="200">
                    </b-input>
                </b-field>
            </div>

        </section>

        <footer class="modal-card-foot has-text-left">
            <!-- <a class="button is-light"
                v-on:click="reset">
                <span>Reset</span>
            </a> -->
            <a class="button is-white"
                v-on:click="triggerClose">
                <span>Close</span>
            </a>
            <a class="button is-success"
                v-on:click="triggerSubmit">
                <!-- v-bind:disabled="!validForm" -->
                <span>Save Changes</span>
            </a>
        </footer>
    </div>
</template>

<style scoped>
</style>





// WEBPACK FOOTER //
// src/components/ChangeStatusForm.vue